// extracted by mini-css-extract-plugin
export var logo = "_kk-2";
export var logoWrapper = "_kk-1";
export var strip = "_kk-0";